import React, { useState } from 'react';
import supabase from '../supabase/supabase';
import { useNavigate } from 'react-router-dom';
import { FiLock } from 'react-icons/fi';

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleAuth = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const { data, error: signInError } = await supabase.auth.signInWithPassword({ email, password });
      if (signInError) throw signInError;

      // Verify admin role
      const { data: profile } = await supabase.from('profiles').select('role').eq('id', data.user.id).single();
      
      if (profile?.role !== 'admin') {
        await supabase.auth.signOut();
        throw new Error('Access denied. Admin privileges required.');
      }

      navigate('/admin');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#1a1c1a] flex items-center justify-center p-6 font-sans">
      <div className="bg-[#232822] p-8 md:p-10 rounded-3xl border border-white/5 shadow-2xl w-full max-w-md relative overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-1 bg-brand-gold"></div>
        
        <div className="flex flex-col items-center mb-8">
          <div className="w-16 h-16 bg-brand-gold/10 rounded-full flex items-center justify-center text-brand-gold mb-4">
            <FiLock className="w-8 h-8" />
          </div>
          <h1 className="text-2xl font-serif text-white mb-2">Ceylanthro Admin</h1>
          <p className="text-white/50 text-sm">Secure Portal Access</p>
        </div>

        {error && <div className="bg-red-500/10 text-red-400 p-3 rounded-lg text-sm mb-6 border border-red-500/20">{error}</div>}

        <form onSubmit={handleAuth} className="space-y-4">
          <div>
            <label className="block text-xs font-semibold text-white/70 uppercase tracking-wider mb-1">Admin Email</label>
            <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full border border-white/10 rounded-xl px-4 py-3 bg-white/5 text-white focus:border-brand-gold outline-none transition-colors" />
          </div>
          <div>
            <label className="block text-xs font-semibold text-white/70 uppercase tracking-wider mb-1">Password</label>
            <input required type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full border border-white/10 rounded-xl px-4 py-3 bg-white/5 text-white focus:border-brand-gold outline-none transition-colors" />
          </div>
          <button disabled={loading} type="submit" className="w-full bg-brand-gold text-[#1a1c1a] py-4 rounded-xl font-bold uppercase tracking-widest text-xs hover:bg-white transition-all mt-6 disabled:opacity-50">
            {loading ? 'Authenticating...' : 'Secure Login'}
          </button>
        </form>
        <div className="mt-6 text-center">
            <button onClick={() => navigate('/')} className="text-xs text-white/40 hover:text-white transition-colors">&larr; Back to Store</button>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;